export const SHOW_OVERFLOW = 'SHOW_OVERFLOW';
export const HIDE_OVERFLOW = 'HIDE_OVERFLOW';
